import { Input } from "@/components/ui";
import { cn } from "@/lib/utils/cn";
import { Search } from "lucide-react";
import pluralize from "pluralize";

type ContactsGeneralSearchProps = {
  value: string;
  onChange: (value: string) => void;
  itemCount?: number;
  className?: string;
};

export function ContactsGeneralSearch({
  value,
  onChange,
  itemCount,
  className,
}: ContactsGeneralSearchProps) {
  return (
    <div className={cn("relative w-full sm:w-80", className)}>
      <Search className="text-muted-foreground pointer-events-none absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2" />
      <Input
        maxLength={200}
        type="search"
        value={value}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        placeholder={
          itemCount === undefined
            ? "Search contacts..."
            : `Search ${pluralize("contact", itemCount, true)}...`
        }
        aria-label="Search contacts"
        autoComplete="off"
        className="pl-9"
      />
    </div>
  );
}
